import { styled } from '@cp/ds/src/theme';
import { Box } from '@cp/ds/src/components/box';
import { name } from './const';

export const TariffPriceSection = styled(Box, { name, slot: 'Price' })(({ theme }) => ({
  ...theme.typography.h3,
}));
